import { render } from "./view-page.vue?vue&type=template&id=55530622"
import script from "./view-page.vue?vue&type=script&lang=js"
export * from "./view-page.vue?vue&type=script&lang=js"
script.render = render

export default script